module.exports = __webpack_public_path__ + "files/SPIADI2026 - DIA INF ADI - Guide Technique (Version 2).b1b73344cde61c202484e3b8179170c8.pdf";